import * as types from "../../constants";
import {
  signIn as authSignIn,
  signUp as authSignUp,
  resetPassword as authResetPassword,
  authChangePassword,
  authenticateWithGoogle as authGoogleSignIn,
  completeGoogleRegistration as authCompleteGoogleRegistration,
} from "../../services/authService";
import { updateBudget } from "../../services/mediaAdsServices";

export function signIn(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return authSignIn(credentials)
      .then((response) => {
        //console.log("INICIE SESION");
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          email: response.email,
          name: response.name,
          balance: response.balance,
        });
        return response;
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function signUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authSignUp(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_UP_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

export function signInWithGoogle(credential) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return authGoogleSignIn(credential)
      .then((response) => {
        if (response?.token) {
          dispatch({
            type: types.AUTH_SIGN_IN_SUCCESS,
            email: response.token.email,
            name: response.token.name,
            balance: response.token.balance,
          });
        }

        return response;
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function completeGoogleSignUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authCompleteGoogleRegistration(credentials)
      .then((response) => {
        if (response?.token) {
          dispatch({
            type: types.AUTH_SIGN_IN_SUCCESS,
            email: response.token.email,
            name: response.token.name,
            balance: response.token.balance,
          });
        }

        return response;
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

export function signOut() {
  return async (dispatch) => {
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}

export function resetPassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authResetPassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}

export function changePassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authChangePassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}

export function updateBalance() {
  //console.log("ENTRE0");
  return async (dispatch) => {
    return updateBudget()
      .then((response) => {
        //console.log("ENTRE1", response);
        dispatch({
          type: types.AUTH_USER_BALANCE_UPDATE_SUCCESS,
          email: response.email,
          name: response.name,
          balance: response.balance,
        });
      })
      .catch((error) => {
        //console.log("ENTRE2", error);
        dispatch({ type: types.AUTH_USER_BALANCE_UPDATE_FAILURE });
        throw error;
      });
  };
}
